export function resolveRestoreSnapshotSelection(
  snapshotIds: readonly string[],
  currentSelection: string | null,
): string | null {
  if (currentSelection !== null && snapshotIds.includes(currentSelection)) {
    return currentSelection;
  }
  return snapshotIds[0] ?? null;
}
